import type { Template } from "@/types";

export const PO_03_H2_V1: Template[] = [
    {
        id: "po-03-h2v2-01",
        name: "PO 01 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 207, width: 498, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 505, y: 207, width: 244, height: 369, rotation: 0, imageRotation: 0 },
            { id: "3", x: 756, y: 207, width: 496, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-02",
        name: "PO 02 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 56, y: 224, width: 452, height: 335, rotation: 0, imageRotation: 0 },
            { id: "2", x: 516, y: 224, width: 222, height: 335, rotation: 0, imageRotation: 0 },
            { id: "3", x: 745, y: 224, width: 450, height: 335, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-03",
        name: "PO 03 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 207, width: 497, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 504, y: 207, width: 497, height: 369, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1009, y: 207, width: 244, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-04",
        name: "PO 04 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 106, y: 146, width: 795, height: 490, rotation: 0, imageRotation: 0 },
            { id: "2", x: 908, y: 146, width: 238, height: 335, rotation: 0, imageRotation: 0 },
            { id: "3", x: 908, y: 488, width: 238, height: 148, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-05",
        name: "PO 05 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 180, y: 95, width: 457, height: 293, rotation: 0, imageRotation: 0 },
            { id: "2", x: 180, y: 395, width: 457, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 644, y: 95, width: 426, height: 593, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-06",
        name: "PO 06 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 85, y: 95, width: 457, height: 293, rotation: 0, imageRotation: 0 },
            { id: "2", x: 85, y: 395, width: 457, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 726, y: 95, width: 426, height: 594, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-07",
        name: "PO 07 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 59, y: 62, width: 507, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 59, y: 396, width: 507, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 703, y: 62, width: 474, height: 661, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-08",
        name: "PO 08 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 100, y: 95, width: 426, height: 594, rotation: 0, imageRotation: 0 },
            { id: "2", x: 711, y: 95, width: 457, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 711, y: 395, width: 457, height: 293, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h2v2-09",
        name: "PO 09 - H2V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h2_v1_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 207, width: 244, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 251, y: 207, width: 497, height: 369, rotation: 0, imageRotation: 0 },
            { id: "3", x: 755, y: 207, width: 497, height: 369, rotation: 0, imageRotation: 0 }
        ],
    }
];